export class ApiClientError extends Error {
  readonly status: number;
  readonly code: string;

  constructor(status: number, code: string, message: string) {
    super(message);
    this.name = 'ApiClientError';
    this.status = status;
    this.code = code;
  }
}

type RequestOptions = {
  readonly method?: 'GET' | 'POST';
  readonly body?: unknown;
  readonly csrfToken?: string | null;
};

export const apiRequest = async <T>(path: string, options: RequestOptions = {}): Promise<T> => {
  const response = await fetch(path, {
    method: options.method ?? 'GET',
    credentials: 'include',
    headers: {
      accept: 'application/json',
      ...(options.body === undefined ? {} : { 'content-type': 'application/json' }),
      ...(options.csrfToken === undefined || options.csrfToken === null
        ? {}
        : { 'x-csrf-token': options.csrfToken }),
    },
    ...(options.body === undefined ? {} : { body: JSON.stringify(options.body) }),
  });
  const body = await response.json().catch(() => null) as { error?: { code?: string; message?: string } } | null;
  if (!response.ok) {
    throw new ApiClientError(
      response.status,
      body?.error?.code ?? 'request_failed',
      body?.error?.message ?? 'Não foi possível concluir a solicitação',
    );
  }
  return body as T;
};
